const Footer = () => {
  return (
    <footer className='footer'>
      <div className='container'>
        <p>
          <strong>Footer</strong>
        </p>
      </div>
    </footer>
  )
}
export default Footer
